module.exports = __webpack_public_path__ + "static/media/r256.38f33b55.jpg";